/**
 * @fileoverview GET handler for the "/engagement/preset_webhook_templates/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementPresetWebhookTemplatesId } from "./constants";
import type { EngagementPresetWebhookTemplatesIdResult } from "./types";

export const getEngagementPresetWebhookTemplatesId = reactQueryFetcherAdapter(
  engagementPresetWebhookTemplatesId,
  (signal: AbortSignal, id: string): Promise<EngagementPresetWebhookTemplatesIdResult> => {
    return fetch(`/engagement/preset_webhook_templates/${id}`, "GET", {}, { signal });
  }
);
